import { z } from 'zod';

export enum JsonFieldType {
  Text = 'text',
  Select = 'select',
  Checkbox = 'checkbox',
}

export const baseJsonField = z.object({
  key: z.string(),
  label: z.string().optional(),
  required: z.boolean().optional(),
  type: z.nativeEnum(JsonFieldType),
});

export const jsonText = baseJsonField.extend({
  type: z.literal(JsonFieldType.Text),
  placeholder: z.string().optional(),
  default: z.string().optional(),
});

export const jsonSelect = baseJsonField.extend({
  type: z.literal(JsonFieldType.Select),
  options: z.array(
    z.object({
      id: z.string(),
      label: z.string(),
    })
  ),
  default: z.string().optional(),
});

export const jsonCheckbox = baseJsonField.extend({
  type: z.literal(JsonFieldType.Checkbox),
  default: z.boolean().optional(),
});

export const jsonField = z.union([jsonText, jsonSelect, jsonCheckbox]);

export const jsonTextArea = z.object({
  label: z.string().optional(),
  placeholder: z.string().optional(),
  default: z.string().optional(),
});

export const jsonCTA = z.object({
  label: z.string(),
  icon: z.string().optional(),
});

export const jsonSchema = z.object({
  textArea: jsonTextArea,
  fields: jsonField.array(),
  cta: jsonCTA,
});
